<div class="coupons-panel">
  <div class="panel-header">
    <h3 class="panel-title">Coupons Section</h3>
    <button class="close-btn" (click)="onClose()" aria-label="Close panel">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="tabs-container">
    <div class="segment-control">
      <button
        class="segment-btn"
        [class.active]="activeTab === 'content'"
        (click)="switchTab('content')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M3 6h12M3 10h12M3 14h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        Content
      </button>
      <button
        class="segment-btn"
        [class.active]="activeTab === 'layout'"
        (click)="switchTab('layout')">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <rect x="3" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="3" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="3" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
          <rect x="10" y="10" width="5" height="5" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        Layout
      </button>
    </div>
  </div>

  <div class="panel-content" *ngIf="activeTab === 'content'">
    <!-- Heading & Paragraph -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('heading')" (click)="toggleSection('heading')">
      <div class="accordion-header">
        <h4 class="section-title">Heading & Paragraph</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('heading')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="accordion-content" *ngIf="isSectionExpanded('heading')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>
        <div class="form-group">
          <label class="form-label">Heading</label>
          <app-text-editor
            [value]="data.title || ''"
            [style]="data.titleStyle || {}"
            placeholder="Exclusive Car Wash Coupons. Deals that shine!"
            (valueChange)="onTitleChange($event)"
            (styleChange)="onTitleStyleChange($event)">
          </app-text-editor>
        </div>

        <div class="form-group">
          <label class="form-label">Paragraph</label>
          <textarea
            class="paragraph-input"
            [value]="data.subtitle || ''"
            (input)="onSubtitleChange($any($event.target).value)"
            placeholder="Save on your next visit! Browse our latest car wash coupons...">
          </textarea>
        </div>
      </div>
    </div>

    <!-- Coupon Card -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('coupon')" (click)="toggleSection('coupon')">
      <div class="accordion-header">
        <h4 class="section-title">Coupon</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('coupon')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="accordion-content" *ngIf="isSectionExpanded('coupon')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>

        <div class="form-group">
          <label class="form-label">Promo label</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="data.promoCodeLabel"
            (ngModelChange)="onCouponFieldChange()"
            placeholder="PROMO CODE"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Promo code</label>
          <input
            type="text"
            class="form-input promo-code-input"
            [(ngModel)]="data.promoCode"
            (ngModelChange)="onCouponFieldChange()"
            placeholder="123 456 789"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Availability text</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="data.availabilityLabel"
            (ngModelChange)="onCouponFieldChange()"
            placeholder="Available for the following washes"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Applicable washes</label>
          <div class="wash-packages-list">
            <div class="wash-package-row" *ngFor="let wash of data.washPackages; let i = index; trackBy: trackByIndex">
              <input
                type="text"
                class="form-input"
                [value]="wash"
                (input)="onWashPackageChange(i, $any($event.target).value)"
                placeholder="e.g. CHAMPION"
              />
              <button type="button" class="icon-btn" (click)="removeWashPackage(i)" aria-label="Remove wash">
                ×
              </button>
            </div>
          </div>
          <button type="button" class="text-btn" (click)="addWashPackage()">+ Add wash</button>
        </div>
      </div>
    </div>

    <!-- Instructions -->
    <div class="accordion-section" [class.expanded]="isSectionExpanded('instruction')" (click)="toggleSection('instruction')">
      <div class="accordion-header">
        <h4 class="section-title">Instruction</h4>
        <button class="collapse-btn" [class.expanded]="isSectionExpanded('instruction')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="accordion-content" *ngIf="isSectionExpanded('instruction')" (click)="$event.stopPropagation()">
        <div class="content-divider"></div>

        <div class="form-group">
          <label class="form-label">Heading</label>
          <input
            type="text"
            class="form-input"
            [(ngModel)]="data.instructionHeading"
            (ngModelChange)="onInstructionHeadingChange()"
            placeholder="How to Use Coupons"
          />
        </div>

        <div class="instruction-steps">
          <div class="instruction-step" *ngFor="let step of data.instructionSteps; let i = index; trackBy: trackByIndex">
            <div class="step-header">
              <span class="step-badge">Step {{ step.stepNumber }}</span>
              <button
                type="button"
                class="icon-btn"
                *ngIf="(data.instructionSteps?.length || 0) > 1"
                (click)="removeInstructionStep(i)"
                aria-label="Remove step">
                ×
              </button>
            </div>
            <div class="form-group">
              <label class="form-label">Title</label>
              <input
                type="text"
                class="form-input"
                [(ngModel)]="step.title"
                (ngModelChange)="onInstructionStepChange()"
                placeholder="Step title"
              />
            </div>
            <div class="form-group">
              <label class="form-label">Description</label>
              <textarea
                class="form-textarea large"
                [(ngModel)]="step.description"
                (ngModelChange)="onInstructionStepChange()"
                placeholder="Step description"
                rows="3"></textarea>
            </div>
          </div>
        </div>

        <button type="button" class="text-btn" (click)="addInstructionStep()">+ Add step</button>
      </div>
    </div>
  </div>

  <div class="panel-content" *ngIf="activeTab === 'layout'">
    <div class="empty-state">
      <p>Layout options coming soon...</p>
    </div>
  </div>
</div>
